import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import PieChart from "react-minimal-pie-chart";
import { FormattedMessage, FormattedNumber, FormattedDate } from "react-intl";

import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Divider from "@material-ui/core/Divider";
// import Table          from '@material-ui/core/Table'
// import TableBody      from '@material-ui/core/TableBody'
// import TableCell      from '@material-ui/core/TableCell'
// import TableHead      from '@material-ui/core/TableHead'
// import TableRow       from '@material-ui/core/TableRow'

// import moment from 'moment'

import { api } from "../../client";
import { communicationToLoadableProps } from "../../project-utils";
import { hasProgramSummary, seesAllPeopleInProcess } from "../../project-utils/permissions";
import { ApplicationState, processesGetRequest, programByIdGetRequest, programsEditRequest, selectProcessesByProgramId, selectProgramById } from "../../redux";
import { PermissionGuard, Loader } from "../atoms";
import { ProgramEditForm } from "../forms";
import { convertEditProgram } from "../forms/schemas";
import withAccountType, { InjectedWithAccountTypeProps } from "../hocs/withAccountType";
import withToggle, { InjectedToggleProps } from "../hocs/withToggle";
import { ProcessTable, ProgramBar, ProgramSummary } from "../molecules";
import styled from "styled-components";
import { SessionStatus } from "../../api";
//import hardLogin from "../../project-utils/hard-login";

const Circle = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${(props: any) => props.color};
  display: inline-block;
  vertical-align: -webkit-baseline-middle;
`;

const CompletedText = styled.span`
  vertical-align: -webkit-baseline-middle;
`;

interface ProgramProps {
  programId: number;
}

interface UploadProps {
  upload: boolean;
}

const mstp = (state: ApplicationState, { programId }: ProgramProps) => ({
  processes: selectProcessesByProgramId(programId)(state),
  program: selectProgramById(programId)(state),
  programByIdGetCommunication: programByIdGetRequest.communicationSelector(state),
  processesGetCommunication: processesGetRequest.communicationSelector(state),
  programsEditCommunication: programsEditRequest.communicationSelector(state),
});

const actions = {
  getProgram: programByIdGetRequest.actionCreator,
  getProcesses: processesGetRequest.actionCreator,
  editProgram: programsEditRequest.actionCreator,
};

type Props = ProgramProps & ReturnType<typeof mstp> & typeof actions & InjectedWithAccountTypeProps & InjectedToggleProps & RouteComponentProps<{}> & UploadProps;

const initState = {
  processesInfo: [],
  upload: false,
  sessionsInfo: [],
};

class Program extends React.Component<Props> {
  public state = initState;
  private readonly exportRequest = api.exportProcesses(this.props.programId);

  public componentDidMount() {
    const { programId, getProcesses, getProgram } = this.props;
    getProgram(programId);
    getProcesses(programId);
  }

  getProcessInfo(processes) {
    processes.map((process) => {
      api
        .getSessions(process.id)
        .then((data) => {
          //let i = 0
          data.results.length &&
            this.setState({
              processesInfo: {
                ...this.state.processesInfo,
                [process.id]: {
                  sessions: data.results.length,
                  doneSessions: Math.round(data.results.filter((session) => session.done).length),
                  pendingSessions: data.results.filter((session) => session.status === SessionStatus.Pending).length,
                  scheduleSessions: data.results.filter((session) => session.status === SessionStatus.Scheduled).length,
                  ListSessions: data.results,
                },
              },
            });
        })
        .catch((err) => {
          this.setState({
            processesInfo: {
              ...this.state.processesInfo,
              [process.id]: {
                sessions: "-",
                doneSessions: "-",
              },
            },
          });
          console.log("There is a error", err);
        });
    });
  }

  public componentDidUpdate(lastProps: Props) {
    const {
      processes,
      program,
      programId,
      getProcesses,
      programsEditCommunication,
      programByIdGetCommunication,
      match: { url },
      history: { replace },
    } = this.props;
    const { success } = programsEditCommunication;

    if (lastProps.programsEditCommunication.fetching && success) {
      getProcesses(programId);
    }

    if (lastProps.processesGetCommunication.success && lastProps.processes !== processes) {
      this.getProcessInfo(processes);
    }

    let { accountType } = this.props;
    if (this.props.program.Role != "") {
      accountType = this.props.program.Role;
    }

    if (!hasProgramSummary(accountType) && processes[0]) {
      replace(`${url}/processes/${processes[0].id}`);
    }

    if (
      /* if couldn't be found*/
      (lastProps.programByIdGetCommunication.fetching && !this.props.programByIdGetCommunication.fetching && !programByIdGetCommunication.success && !program) ||
      /* if has been deleted */
      (lastProps.program && !program)
    ) {
      replace(`/dashboard/programs`);
    }
  }

  private getStatisticProcesses(processes, info) {
    if (processes.length === Object.keys(info).length && processes.length > 0) {
      let listSessions = [] as any;
      Object.keys(info).forEach((key) => {
        listSessions.push(info[key].ListSessions);
      });
      let cuenta = new Array(listSessions[0].length).fill(0);
      listSessions.forEach((element) => {
        element.forEach((item, i) => {
          if (item.status === "done") cuenta[i] += 1;
        });
      });
      if (listSessions.length > 0) {
        cuenta[listSessions[0].length] = listSessions[0].length * listSessions.length - cuenta.reduce((a, b) => a + b, 0);
      }
      return {
        totalProcesses: processes.length,
        completedProcesses: processes.filter((process) => info[process.id].sessions === info[process.id].doneSessions).length,
        ongoingProcesses: processes.filter((process) => info[process.id].pendingSessions !== info[process.id].sessions && info[process.id].doneSessions < info[process.id].sessions).length,
        notStarted: processes.filter((process) => info[process.id].pendingSessions === info[process.id].sessions).length,
        sessions: cuenta,
      };
    }

    return {
      totalProcesses: 0,
      completedProcesses: 0,
      ongoingProcesses: 0,
      notStarted: 0,
      sessions: [],
    };
  }

  private getStatisticSessions(processes) {
    let statisticSessions = {
      totalSessions: 0,
      doneSessions: 0,
      pendingSessions: 0,
      scheduleSessions: 0,
    };
    Object.keys(processes).forEach((process) => {
      statisticSessions.totalSessions += processes[process].sessions;
      statisticSessions.doneSessions += processes[process].doneSessions;
      statisticSessions.pendingSessions += processes[process].pendingSessions;
      statisticSessions.scheduleSessions += processes[process].scheduleSessions;
    });

    return statisticSessions;
  }

  public render() {
    const { program, processes } = this.props;
    // const finishedProcesses = program.statistics.totalProcesses - program.statistics.ongoingProcesses +  program.statistics.pendingProcesses
    const infoStatisticProcesses = this.getStatisticProcesses(processes, this.state.processesInfo);
    const infoStatisticSessions = this.getStatisticSessions(this.state.processesInfo);
    // const today = moment(new Date())
    const totalMentors = processes.reduce((acc, next) => {
      const mentor = next.teacher.email;
      return acc.includes(mentor) ? acc : [...acc, mentor];
    }, []);

    const totalMentees = processes.reduce((acc, next) => {
      const mentee = next.student.email;
      return acc.includes(mentee) ? acc : [...acc, mentee];
    }, []);

    if (!program.statistics) {
      return <Loader />;
    }
    return (
      <PermissionGuard check={hasProgramSummary}>
        <Grid container spacing={24} direction={"column"}>
          <Grid item>{this.renderTopBar()}</Grid>
          <Grid item>{this.renderProgramSummary()}</Grid>
          <Grid container spacing={32} style={{ marginBottom: 14 }}>
            <Grid item xs={4}>
              <Card>
                <CardHeader title={<FormattedMessage id={"labels.startDate"} />} />
                <Divider />
                <CardContent>
                  <Typography>
                    <FormattedDate value={program.details.start} year={"numeric"} month={"2-digit"} day={"2-digit"} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card>
                <CardHeader title={<FormattedMessage id={"labels.endDate"} />} />
                <Divider />
                <CardContent>
                  <Typography>
                    <FormattedDate value={program.details.end} year={"numeric"} month={"2-digit"} day={"2-digit"} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={4}>
              <Card>
                <CardHeader title={<FormattedMessage id={"statistics.totalSessionsSimple"} />} />
                <Divider />
                <CardContent>
                  <Typography>{program.details.sessions}</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={16}>
            <PermissionGuard check={seesAllPeopleInProcess}>
              <Grid item xs={4}>
                <Card>
                  <CardHeader title={<FormattedMessage id={"statistics.totalMentors"} />} />
                  <Divider />
                  <CardContent>
                    <Typography>{totalMentors.length}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </PermissionGuard>
            <Grid item xs={4}>
              <Card>
                <CardHeader title={<FormattedMessage id={"statistics.totalMentees"} />} />
                <Divider />
                <CardContent>
                  <Typography>{totalMentees.length}</Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid item>
            {this.renderTest(
              "statistics.progressSessions",
              infoStatisticSessions.totalSessions, //program.statistics.totalSessions,
              infoStatisticSessions.doneSessions, //program.statistics.finishedSessions,
              infoStatisticSessions.scheduleSessions, //program.statistics.ongoingSessions,
              infoStatisticSessions.pendingSessions, //program.statistics.pendingSessions,
              "statistics.completedSessions",
              "statistics.scheduledSessions",
              "statistics.pendingSessions",
              "statistics.totalSessions"
            )}

            {/* {this.renderTest(
                "statistics.scheduledSessions",
                program.statistics.totalProcesses,
                program.statistics.ongoingProcesses,
                "statistics.pending",
                "statistics.processing",
                "statistics.totalProcesses",
                "statistics.ongoingProcesses",
                false
              )}

              {this.renderTest(
                "statistics.pendingSessions",
                program.statistics.totalSessions,
                program.statistics.pendingSessions,
                "statistics.completedAndScheduled",
                "statistics.pending",
                "statistics.totalSessions",
                "statistics.totalSessionsPending",
                false
              )} */}
            {/* {this.renderTest(
              "statistics.progressProcesses",
              infoStatisticProcesses.totalProcesses, //program.statistics.totalProcesses,
              infoStatisticProcesses.completedProcesses, //finishedProcesses,
              infoStatisticProcesses.ongoingProcesses, // program.statistics.ongoingProcesses,
              infoStatisticProcesses.notStarted,
              "statistics.finishedProcesses",
              "statistics.pendingProcesses",
              "statistics.nopendingProcesses",
              "statistics.totalProcesses"
            )} */}
            {this.renderSessions(
              "statistics.progressSessions",
              infoStatisticSessions.totalSessions, //program.statistics.totalProcesses,
              infoStatisticProcesses.completedProcesses, //finishedProcesses,
              infoStatisticSessions.scheduleSessions, // program.statistics.ongoingProcesses,
              infoStatisticSessions.pendingSessions,
              infoStatisticProcesses.sessions,
              "statistics.finishedProcesses",
              "statistics.pendingProcesses",
              "statistics.nopendingProcesses",
              "statistics.totalSessions"
            )}
          </Grid>
          <Grid item>
            <div style={{ display: "none" }}>{this.renderProgramStats()}</div>
          </Grid>
          <Grid item>{this.renderProcessTable()}</Grid>
        </Grid>
        {this.renderEditProgramForm()}
      </PermissionGuard>
    );
  }

  private upload = () => {
    this.props.getProcesses(this.props.programId);
  };

  private renderTopBar = () => {
    const { activate, programId } = this.props;

    return <ProgramBar exportRequest={this.exportRequest} onAddClick={activate} programId={programId} onUpload={this.upload} />;
  };

  private renderEditProgramForm = () => {
    const {
      program,
      processes,
      programsEditCommunication,
      processesGetCommunication,

      deactivate,
      isActive,
    } = this.props;

    const programValues = program
      ? {
          ...program.company,
          ...program.details,
          processes,
          automaticMatch: program.automaticMatch,
          id: program.id,
        }
      : {};
    return (
      <ProgramEditForm
        onSubmit={this.editProgram}
        close={deactivate}
        isOpen={isActive}
        values={programValues}
        isCached={processesGetCommunication.success}
        {...programsEditCommunication}
        {...communicationToLoadableProps(processesGetCommunication)}
      />
    );
  };

  private renderTest = (
    title,
    total,
    finished, //current,
    inprogress,
    tobedone,
    finishedPhrase,
    inprogressPhrase,
    tobedonePhrase,
    bottomTotalPhrase
  ) => {
    const {
      //program,
    } = this.props;

    const finishedColor = "#e8e8e8";
    const inprogressColor = "#03657c";
    const tobedoneColor = "#004254";

    const pieChartData = [
      { value: finished, color: finishedColor },
      { value: inprogress, color: inprogressColor },
      { value: tobedone, color: tobedoneColor },
    ];

    return (
      <Grid
        style={{
          float: "left",
          minWidth: "430px",
          width: "50%",
          margin: "20px 0 70px 0",
        }}
        item
      >
        <div style={{ margin: "0 auto", maxWidth: "440px" }}>
          <Grid item>
            <Typography variant={"subheading"}>
              <FormattedMessage id={title} />
              <div style={{ height: "30px" }}></div>
            </Typography>
          </Grid>
          <PieChart style={{ width: 200, height: 200, float: "left" }} startAngle={270} data={pieChartData} />
          <div style={{ margin: "70px 0 0 30px", float: "left" }}>
            <Typography style={{ verticalAlign: "-webkit-baseline-middle" }} variant={"caption"}>
              <Circle color={finishedColor} />
              <CompletedText style={{ verticalAlign: "-webkit-baseline-middle" }}>
                {" "}
                {finished} <FormattedMessage id={finishedPhrase} />
              </CompletedText>
            </Typography>
            <Typography style={{ verticalAlign: "-webkit-baseline-middle" }} variant={"caption"}>
              <Circle color={inprogressColor} />
              <CompletedText style={{ verticalAlign: "-webkit-baseline-middle" }}>
                {" "}
                {inprogress} <FormattedMessage id={inprogressPhrase} />
              </CompletedText>
            </Typography>
            <Typography style={{ verticalAlign: "-webkit-baseline-middle" }} variant={"caption"}>
              <Circle color={tobedoneColor} />
              <CompletedText style={{ verticalAlign: "-webkit-baseline-middle" }}>
                {" "}
                {tobedone} <FormattedMessage id={tobedonePhrase} />
              </CompletedText>
            </Typography>
          </div>
          <div style={{ clear: "both", height: "20px" }}></div>
          <Typography>
            <FormattedMessage id={bottomTotalPhrase} values={{ value: total }} />
          </Typography>
        </div>
      </Grid>
    );
  };

  private renderSessions = (
    title,
    total,
    finished, //current,
    scheduled,
    tobedone,
    sessions,
    finishedPhrase,
    inprogressPhrase,
    tobedonePhrase,
    bottomTotalPhrase
  ) => {
    const {
      //program,
    } = this.props;

    interface Circles {
      value: number;
      color: string;
    }

    // const finishedColor = "#e8e8e8";
    // const inprogressColor = "#03657c";
    // const tobedoneColor = "#004254";

    // const pieChartData = [
    //   { value: finished, color: finishedColor },
    //   { value: inprogress, color: inprogressColor },
    //   { value: tobedone, color: tobedoneColor },
    // ];
    const colors = ["#03657c", "#4472C4", "#205B8E", "#636363", "#264478", "#7CAFDD", "#4472E4", "#205BEF", "#636393", "#264498", "#03689C"];

    let pieChartData: Circles[];
    if (sessions === undefined) {
      return;
    }
    pieChartData = sessions.map((item, i) => {
      return {
        value: item,
        color: colors[i],
      };
    });

    return (
      <Grid
        style={{
          float: "left",
          minWidth: "430px",
          width: "50%",
          margin: "20px 0 70px 0",
        }}
        item
      >
        <div style={{ margin: "0 auto", maxWidth: "440px" }}>
          <Grid item>
            <Typography variant={"subheading"}>
              <FormattedMessage id={title} />
              <div style={{ height: "30px" }}></div>
            </Typography>
          </Grid>
          <PieChart style={{ width: 200, height: 200, float: "left" }} startAngle={270} data={pieChartData} />
          <div style={{ margin: "0px 0 0 30px", float: "left" }}>
            <Typography style={{ verticalAlign: "-webkit-baseline-middle" }} variant={"caption"}>
              <Circle color={colors[pieChartData.length - 1]} />
              <CompletedText style={{ verticalAlign: "-webkit-baseline-middle" }}>
                {" "}
                {tobedone + scheduled} <FormattedMessage id={"Sin iniciar"} />
              </CompletedText>
            </Typography>
            {pieChartData.map((item, i) => {
              return (
                i < pieChartData.length - 1 &&
                item.value != 0 && (
                  <Typography style={{ verticalAlign: "-webkit-baseline-middle" }} variant={"caption"}>
                    <Circle color={colors[i]} />
                    <CompletedText style={{ verticalAlign: "-webkit-baseline-middle" }}>
                      {" "}
                      {item.value}
                      {" en "} {i + 1} <FormattedMessage id={"ª session"} />
                    </CompletedText>
                  </Typography>
                )
              );
            })}

            {/* <Typography
              style={{ verticalAlign: "-webkit-baseline-middle" }}
              variant={"caption"}
            >
              <Circle color={inprogressColor} />
              <CompletedText
                style={{ verticalAlign: "-webkit-baseline-middle" }}
              >
                {" "}
                {inprogress} <FormattedMessage id={inprogressPhrase} />
              </CompletedText>
            </Typography>
            <Typography
              style={{ verticalAlign: "-webkit-baseline-middle" }}
              variant={"caption"}
            >
              <Circle color={tobedoneColor} />
              <CompletedText
                style={{ verticalAlign: "-webkit-baseline-middle" }}
              >
                {" "}
                {tobedone} <FormattedMessage id={tobedonePhrase} />
              </CompletedText>
            </Typography> */}
          </div>
          <div style={{ clear: "both", height: "20px" }}></div>
          <Typography>
            <FormattedMessage id={bottomTotalPhrase} values={{ value: total }} />
          </Typography>
        </div>
      </Grid>
    );
  };
  // private renderDaysToFinishProgram = (today) => {
  //   const {
  //     program,
  //   } = this.props
  //   const t = today
  //   const d = moment(program.details.end)
  //   const daysRemaining = d.diff(t, 'days')
  //   return daysRemaining > 0 ? daysRemaining : 0
  // }

  private renderProgramSummary = () => {
    const { program, programByIdGetCommunication } = this.props;

    return <ProgramSummary isCached={Boolean(program)} program={program} {...communicationToLoadableProps(programByIdGetCommunication)} />;
  };

  private renderProcessTable = () => {
    const { processes, processesGetCommunication } = this.props;
    const { processesInfo } = this.state;

    return (
      <ProcessTable
        onProcessClick={this.handleProcessClick}
        isCached={!!processes.length}
        processes={processes}
        processesInfo={processesInfo}
        {...communicationToLoadableProps(processesGetCommunication)}
      />
    );
  };

  // TODO: I have no idea what I am doing. Don't judge!
  private renderProgramStats = () => {
    const { program } = this.props;

    // TODO: there is no way to get these values yet
    const daysRemaining = 278;
    const averageDoneSessionByDays2 = 1.98;

    const phrasing = {
      totalSessions: <FormattedMessage id={"statistics.totalSessions"} values={{ value: program.statistics.totalSessions }} />,
      totalSessionsFinished: <FormattedMessage id={"statistics.totalSessionsFinished"} values={{ value: program.statistics.finishedSessions }} />,
      totalSessionsOngoing: <FormattedMessage id={"statistics.totalSessionsOngoing"} values={{ value: program.statistics.ongoingSessions }} />,
      totalSessionsPending: <FormattedMessage id={"statistics.totalSessionsPending"} values={{ value: program.statistics.pendingSessions }} />,
      averageSessionsFinished: <FormattedMessage id={"statistics.averageSessionsFinished"} values={{ value: program.statistics.averageDoneSessions }} />,
      totalProcessesNoSessions: <FormattedMessage id={"statistics.totalProcessesNoSessions"} values={{ value: program.statistics.pendingProcesses }} />,
      daysRemaining: <FormattedMessage id={"statistics.daysRemaining"} values={{ value: daysRemaining }} />,
      averageSessionsPerDay: (
        <FormattedMessage
          id={"statistics.averageSessionsPerDay"}
          values={{
            value: <FormattedNumber value={program.statistics.averageDoneSessionByDays} maximumFractionDigits={2} />,
          }}
        />
      ),
      averageSessionsPerDay2: (
        <FormattedMessage
          id={"statistics.averageSessionsPerDay2"}
          values={{
            value: <FormattedNumber value={averageDoneSessionByDays2} maximumFractionDigits={2} />,
          }}
        />
      ),
    };

    return (
      <div>
        <Typography>{phrasing.totalSessions}</Typography>
        <Typography>{phrasing.totalSessionsFinished}</Typography>
        <Typography>{phrasing.totalSessionsOngoing}</Typography>
        <Typography>{phrasing.totalSessionsPending}</Typography>
        <Typography>{phrasing.averageSessionsFinished}</Typography>
        <Typography>{phrasing.totalProcessesNoSessions}</Typography>
        <Typography>{phrasing.daysRemaining}</Typography>
        <Typography>{phrasing.averageSessionsPerDay}</Typography>
        <Typography>{phrasing.averageSessionsPerDay2}</Typography>
      </div>
    );
  };

  private editProgram = (values) => {
    const { editProgram, programId } = this.props;

    convertEditProgram(editProgram)(programId, values);
  };

  private handleProcessClick = (processId) => {
    this.redirectToProcess(processId);
  };

  private redirectToProcess = (processId) => {
    const {
      match: { url },
      history: { push },
    } = this.props;

    push(`${url}/processes/${processId}`);
  };
}

export default connect(mstp, actions)(withRouter(withAccountType(withToggle(Program))));



// WEBPACK FOOTER //
// ./src/components/environments/Program.tsx